import { Tag as RACTag } from 'react-aria-components';
import styles from './styles.module.css';
import { TagGroup, TagList } from 'react-aria-components';
import { Link } from 'react-router-dom';

import { flattenToAppURL, getBaseUrl } from '@plone/volto/helpers/Url/Url';

type TagProps = {
  tagName: string;
  id: string;
  href?: string;
  openLinkInNewTab?: boolean;
  cameFrom?: string;
};

const Tag = ({
  tagName,
  id,
  openLinkInNewTab = false,
  cameFrom = '',
  href,
}: TagProps) => {
  const tagUrl = `/news/tag?name=${encodeURIComponent(id)}${cameFrom ? `&cameFrom=${cameFrom}` : ''}`;
  return (
    <RACTag target={openLinkInNewTab ? '_blank' : '_self'} id={id}>
      <Link
        to={id === 'more-tags' ? flattenToAppURL(href) : tagUrl}
        className={styles.tag}
      >{`#${tagName}`}</Link>
    </RACTag>
  );
};
const Tags = ({
  items,
  ariaLabel,
}: {
  items: TagProps[];
  ariaLabel: string;
}) => {
  return (
    <TagGroup aria-label={ariaLabel}>
      <TagList items={items} className={styles.tagGroup}>
        {(item) => <Tag key={item.tagName} {...item} />}
      </TagList>
    </TagGroup>
  );
};
export { Tags, Tag };
export type { TagProps };
